import { PaymentFieldKeys, PaymentModeType } from '../../constants';
import { getCurrencySign } from '@zonofi/common/functions/format-amount';

export const initialPaymentModeData = [
  { label: PaymentModeType.CASH, value: PaymentModeType.CASH },
  { label: PaymentModeType.CHQ, value: PaymentModeType.CHQ },
  { label: PaymentModeType.UPI, value: PaymentModeType.UPI },
  { label: PaymentModeType.DD, value: PaymentModeType.DD },
  { label: PaymentModeType.BNTR, value: PaymentModeType.BNTR },
  { label: PaymentModeType.CREDIT_CARD, value: PaymentModeType.CREDIT_CARD },
];

export const defaultPaymentDetails = [
  {
    key: PaymentFieldKeys.PAYMENT_MODE,
    label: 'Payment Mode',
    type: 'dropdown',
    required: true,
  },
  {
    key: PaymentFieldKeys.AMOUNT_PAID,
    label: 'Amount Paid',
    required: true,
    prefix: getCurrencySign(),
  },
  {
    key: PaymentFieldKeys.PAYMENT_DATE,
    label: 'Payment Date',
    type: 'date',
    required: true,
  },
  {
    key: PaymentFieldKeys.PAYMENT_TIME,
    label: 'Payment Time',
    type: 'time',
    required: true,
  },
  {
    key: PaymentFieldKeys.PAYMENT_REFERENCE_CODE,
    label: 'Doc Number',
    required: true,
  },
];

export const commonFields = [
  {
    key: PaymentFieldKeys.BANK_NAME,
    label: 'Bank Name',
    required: true,
  },
  {
    key: PaymentFieldKeys.BANK_ACCOUNT_NUMBER,
    label: 'Account Number',
  },
  {
    key: PaymentFieldKeys.NARRATION,
    label: 'Narration',
  },
];

export const paymentTypeFields: Record<
  PaymentModeType,
  {
    key: PaymentFieldKeys;
    label: string;
    required?: boolean;
  }[]
> = {
  [PaymentModeType.CHQ]: [
    {
      key: PaymentFieldKeys.INSTRUMENT_NUMBER,
      label: 'Cheque Number',
      required: true,
    },
    ...commonFields,
  ],
  [PaymentModeType.DD]: [
    {
      key: PaymentFieldKeys.INSTRUMENT_NUMBER,
      label: 'Demand Draft Number',
      required: true,
    },
    ...commonFields.map((field) =>
      field.key === PaymentFieldKeys.BANK_ACCOUNT_NUMBER
        ? { ...field, required: true }
        : field
    ),
  ],
  [PaymentModeType.BNTR]: [
    ...commonFields.map((field) =>
      field.key === PaymentFieldKeys.BANK_ACCOUNT_NUMBER
        ? { ...field, required: true }
        : field
    ),
    { key: PaymentFieldKeys.BANK_REFERENCE, label: 'UTR No' },
  ],
  [PaymentModeType.CASH]: commonFields.filter(
    (field) =>
      field.key !== PaymentFieldKeys.BANK_NAME &&
      field.key !== PaymentFieldKeys.BANK_ACCOUNT_NUMBER
  ),
  [PaymentModeType.UPI]: [
    ...commonFields.filter(
      (field) =>
        field.key !== PaymentFieldKeys.BANK_NAME &&
        field.key !== PaymentFieldKeys.BANK_ACCOUNT_NUMBER
    ),
    { key: PaymentFieldKeys.UPI_ID, label: 'UPI ID', required: true },
    { key: PaymentFieldKeys.BANK_REFERENCE, label: 'UTR No', required: true },
  ],
  [PaymentModeType.CREDIT_CARD]: [
    ...commonFields.filter(
      (field) =>
        field.key !== PaymentFieldKeys.BANK_NAME &&
        field.key !== PaymentFieldKeys.BANK_ACCOUNT_NUMBER
    ),
    {
      key: PaymentFieldKeys.CARD_NUMBER,
      label: 'Credit/Debit Card Number',
      required: true,
    },
    { key: PaymentFieldKeys.CARD_TYPE, label: 'Card Type' },
    { key: PaymentFieldKeys.PAYMENT_PROVIDER, label: 'Provider' },
  ],
};
